import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { AppConfig } from '../../app/app.config';

/*
  追号页面
  TQQ 2017-01-11
*/
@Component({
    selector: 'page-reward',
    templateUrl: 'reward.html'
})
export class RewardPage {

    rewards=[];
    constructor(
        private navPar: NavParams
    ) {
        this.rewards=this.navPar.get("rewards");
        console.log("--------------------",this.rewards);
    }
}

@Component({
    selector: 'page-UserMoney',
    template: `
        <ion-label style="text-align:center">余额{{AppConfig.User.UserMoney}}元</ion-label>
    `
})

export class UserMoneyPage {
    AppConfig = AppConfig;
    constructor(
        private navPar: NavParams
    ) {

    }
}



// WEBPACK FOOTER //
// ./src/pages/bettingorder/reward.ts